/**
 * Parse a YYYY-MM-DD date string as local noon.
 * Prevents the timezone bug where new Date('2026-05-23') is parsed as
 * UTC midnight, which in US timezones rolls back to the previous evening
 * and returns the wrong day-of-week.
 */
export function parseLocalDate(dateStr) {
  return new Date(dateStr + 'T12:00:00');
}
